/**
 * MiniSolo Inspiration Assistant
 * Spruch-Helfer mit 3 Zeilen für den Mini-Topf
 */

(function() {
  'use strict';

  // ========================================
  // KATEGORIEN
  // ========================================
  const CATEGORIES = [
    { id: 'motivation', emoji: '💪', label: 'Motivation' },
    { id: 'love', emoji: '💕', label: 'Liebe' },
    { id: 'plants', emoji: '🌱', label: 'Pflanzen' },
    { id: 'humor', emoji: '😄', label: 'Humor' },
    { id: 'thanks', emoji: '🙏', label: 'Danke' },
    { id: 'random', emoji: '🎲', label: 'Zufällig' }
  ];

  // ========================================
  // SPRUCH-DATENBANK (3 Zeilen)
  // ========================================
  const PHRASES = {
    motivation: [
      { line1: 'TRÄUME GROSS', line2: 'ARBEITE HART', line3: 'BLEIB DEMÜTIG' },
      { line1: 'NIEMALS', line2: 'AUFGEBEN', line3: 'DU SCHAFFST DAS' },
      { line1: 'SEI MUTIG', line2: 'SEI STARK', line3: 'SEI DU SELBST' },
      { line1: 'JEDEN TAG', line2: 'EIN BISSCHEN', line3: 'BESSER' },
      { line1: 'GLAUB AN', line2: 'DICH', line3: 'SELBST' },
      { line1: 'MACH ES', line2: 'EINFACH', line3: 'JETZT' },
      { line1: 'DU BIST', line2: 'STÄRKER ALS', line3: 'DU DENKST' },
      { line1: 'KLEINE', line2: 'SCHRITTE', line3: 'GROSSES ZIEL' },
      { line1: 'HEUTE IST', line2: 'EIN GUTER', line3: 'TAG' },
      { line1: 'WACHSE', line2: 'ÜBER DICH', line3: 'HINAUS' }
    ],
    love: [
      { line1: 'ICH LIEBE', line2: 'DICH', line3: 'UNENDLICH' },
      { line1: 'DU BIST', line2: 'MEIN', line3: 'ZUHAUSE' },
      { line1: 'FÜR IMMER', line2: 'UND', line3: 'EWIG' },
      { line1: 'MEIN HERZ', line2: 'GEHÖRT', line3: 'DIR' },
      { line1: 'ZUSAMMEN', line2: 'SIND WIR', line3: 'UNSCHLAGBAR' },
      { line1: 'DU UND', line2: 'ICH', line3: 'FÜR IMMER' },
      { line1: 'LIEBE', line2: 'LACHT', line3: 'LEBT' },
      { line1: 'BESTE', line2: 'FREUNDIN', line3: 'EVER' },
      { line1: 'WAHRE', line2: 'LIEBE', line3: 'WÄCHST' },
      { line1: 'DANKE', line2: 'FÜR', line3: 'DICH' }
    ],
    plants: [
      { line1: 'BITTE NUR', line2: 'POSITIVE VIBES', line3: 'UND WASSER' },
      { line1: 'WACHSE', line2: 'MIT', line3: 'MIR' },
      { line1: 'PFLANZEN', line2: 'MACHEN', line3: 'GLÜCKLICH' },
      { line1: 'GRÜNER', line2: 'DAUMEN', line3: 'IN ARBEIT' },
      { line1: 'HIER WÄCHST', line2: 'DIE', line3: 'LIEBE' },
      { line1: 'SONNE', line2: 'WASSER', line3: 'LIEBE' },
      { line1: 'KLEIN ABER', line2: 'VOLLER', line3: 'LEBEN' },
      { line1: 'NATURE', line2: 'IS', line3: 'MAGIC' },
      { line1: 'BLOOM', line2: 'WHERE YOU', line3: 'ARE PLANTED' },
      { line1: 'LET IT', line2: 'GROW', line3: 'BABY' }
    ],
    humor: [
      { line1: 'BITTE', line2: 'NICHT', line3: 'STERBEN' },
      { line1: 'ICH REDE', line2: 'MIT MEINEN', line3: 'PFLANZEN' },
      { line1: 'PFLANZE', line2: 'ÜBERLEBT', line3: '(BISHER)' },
      { line1: 'GRÜNER', line2: 'DAUMEN?', line3: 'NAJA...' },
      { line1: 'VERSUCH', line2: 'NUMMER', line3: '47' },
      { line1: 'HOFFENTLICH', line2: 'KLAPPTS', line3: 'DIESMAL' },
      { line1: 'DRAMA', line2: 'QUEEN', line3: 'PFLANZE' },
      { line1: 'KAKTUS', line2: 'HÄTTE', line3: 'GEKLAPPT' },
      { line1: 'WASSER?', line2: 'ACH JA', line3: 'STIMMT' },
      { line1: 'WIR WACHSEN', line2: 'ZUSAMMEN', line3: '(HOFFENTLICH)' }
    ],
    thanks: [
      { line1: 'DANKE FÜR', line2: 'ALLES', line3: 'MAMA' },
      { line1: 'DANKE FÜR', line2: 'ALLES', line3: 'PAPA' },
      { line1: 'BESTE', line2: 'OMA', line3: 'DER WELT' },
      { line1: 'BESTE', line2: 'FREUNDIN', line3: 'EVER' },
      { line1: 'DANKE', line2: 'DASS ES', line3: 'DICH GIBT' },
      { line1: 'DU BIST', line2: 'EIN', line3: 'GESCHENK' },
      { line1: 'VON', line2: 'HERZEN', line3: 'DANKE' },
      { line1: 'FÜR DICH', line2: 'MIT', line3: 'LIEBE' },
      { line1: 'EINFACH', line2: 'NUR', line3: 'DANKE' },
      { line1: 'DU BIST', line2: 'DIE', line3: 'BESTE' }
    ]
  };

  // Zufällige witzige Sprüche
  const RANDOM_PHRASES = [
    { line1: 'ICH BIN', line2: 'KEIN', line3: 'KAKTUS' },
    { line1: 'BITTE', line2: 'GIESSEN', line3: 'DANKE' },
    { line1: 'HALT DICH', line2: 'FERN VON', line3: 'MEINER ERDE' },
    { line1: 'CRAZY', line2: 'PLANT', line3: 'LADY' },
    { line1: 'PLANT', line2: 'MOM', line3: 'LIFE' },
    { line1: 'GUTEN', line2: 'MORGEN', line3: 'SONNENSCHEIN' },
    { line1: 'HEUTE', line2: 'SCHON', line3: 'GELÄCHELT?' },
    { line1: 'MACH MAL', line2: 'PAUSE', line3: 'HIER' },
    { line1: 'GOOD', line2: 'VIBES', line3: 'ONLY' },
    { line1: 'STAY', line2: 'WILD', line3: 'CHILD' },
    { line1: 'BE', line2: 'HAPPY', line3: 'NOW' },
    { line1: 'COFFEE', line2: 'FIRST', line3: 'PLEASE' },
    { line1: 'LESS', line2: 'DRAMA', line3: 'MORE PLANTS' },
    { line1: 'WEIN', line2: 'NICHT', line3: 'LÄCHLE' },
    { line1: 'CHAOS', line2: 'QUEEN', line3: 'LEBT HIER' }
  ];

  // ========================================
  // STATE
  // ========================================
  let currentStep = 'category';
  let selectedCategory = null;
  let selectedPhrase = null;

  // ========================================
  // DOM ELEMENTS
  // ========================================
  const modal = document.getElementById('minisolo-inspiration-modal');
  const openBtn = document.getElementById('minisolo-open-inspiration');
  const closeBtn = document.getElementById('minisolo-inspiration-close');
  const backBtn = document.getElementById('minisolo-inspiration-back');
  const applyBtn = document.getElementById('minisolo-apply-inspiration');
  const categoryGrid = document.getElementById('minisolo-category-grid');
  const phraseOptions = document.getElementById('minisolo-phrase-options');
  const phrasesTitle = document.getElementById('minisolo-phrases-title');

  if (!modal || !openBtn) return;

  // ========================================
  // FUNCTIONS
  // ========================================

  function openModal() {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    resetWizard();
    renderCategories();
  }

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function resetWizard() {
    currentStep = 'category';
    selectedCategory = null;
    selectedPhrase = null;
    updateStepVisibility();
    updateBackButton();
    applyBtn.disabled = true;
  }

  function updateStepVisibility() {
    document.querySelectorAll('.minisolo-wizard-step').forEach(step => {
      step.classList.remove('active');
    });
    if (currentStep === 'category') {
      document.getElementById('minisolo-step-category').classList.add('active');
    } else {
      document.getElementById('minisolo-step-phrases').classList.add('active');
    }
  }

  function updateBackButton() {
    if (currentStep === 'category') {
      backBtn.classList.remove('visible');
    } else {
      backBtn.classList.add('visible');
    }
  }

  function goBack() {
    currentStep = 'category';
    selectedCategory = null;
    selectedPhrase = null;
    applyBtn.disabled = true;
    updateStepVisibility();
    updateBackButton();
  }

  function renderCategories() {
    categoryGrid.innerHTML = '';
    CATEGORIES.forEach(cat => {
      const card = document.createElement('div');
      card.className = 'minisolo-category-card';
      card.innerHTML = `
        <span class="minisolo-category-emoji">${cat.emoji}</span>
        <span class="minisolo-category-label">${cat.label}</span>
      `;
      card.addEventListener('click', () => selectCategory(cat.id));
      categoryGrid.appendChild(card);
    });
  }

  function selectCategory(categoryId) {
    selectedCategory = categoryId;

    if (categoryId === 'random') {
      // Zufälligen Spruch direkt anwenden
      const randomIndex = Math.floor(Math.random() * RANDOM_PHRASES.length);
      const phrase = RANDOM_PHRASES[randomIndex];
      applyPhrase(phrase);
      closeModal();
      return;
    }

    currentStep = 'phrases';
    updateStepVisibility();
    updateBackButton();
    renderPhrases();
  }

  function renderPhrases() {
    const phrases = PHRASES[selectedCategory];
    if (!phrases) return;

    const category = CATEGORIES.find(c => c.id === selectedCategory);
    phrasesTitle.textContent = category.emoji + ' ' + category.label;

    phraseOptions.innerHTML = '';
    phrases.forEach((phrase, index) => {
      const option = document.createElement('div');
      option.className = 'minisolo-phrase-option';
      option.innerHTML = `
        <span class="minisolo-phrase-line">${phrase.line1}</span>
        <span class="minisolo-phrase-line">${phrase.line2}</span>
        <span class="minisolo-phrase-line">${phrase.line3}</span>
      `;
      option.addEventListener('click', () => selectPhrase(phrase, option));
      phraseOptions.appendChild(option);
    });
  }

  function selectPhrase(phrase, element) {
    selectedPhrase = phrase;

    // Update visual selection
    document.querySelectorAll('.minisolo-phrase-option').forEach(opt => {
      opt.classList.remove('selected');
    });
    element.classList.add('selected');

    applyBtn.disabled = false;
  }

  function applyPhrase(phrase) {
    // Fill in the text fields
    const line1Input = document.getElementById('minisolo-line1');
    const line2Input = document.getElementById('minisolo-line2');
    const line3Input = document.getElementById('minisolo-line3');

    if (line1Input) line1Input.value = phrase.line1;
    if (line2Input) line2Input.value = phrase.line2;
    if (line3Input) line3Input.value = phrase.line3;

    // Trigger input events for preview update
    [line1Input, line2Input, line3Input].forEach(input => {
      if (input) {
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  function applyInspiration() {
    if (!selectedPhrase) return;
    applyPhrase(selectedPhrase);
    closeModal();
  }

  // ========================================
  // EVENT LISTENERS
  // ========================================

  openBtn.addEventListener('click', openModal);

  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  if (backBtn) {
    backBtn.addEventListener('click', goBack);
  }

  if (applyBtn) {
    applyBtn.addEventListener('click', applyInspiration);
  }

  // Close on outside click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeModal();
    }
  });

})();
